import { useEffect, useRef } from 'react';

interface useSideMenuProps {
  isMenuActive: boolean;
  onOpenMenu: () => void;
}

// Run a callback function when the side menu is active / opened
export const useSideMenu = ({ isMenuActive, onOpenMenu }: useSideMenuProps) => {
  const onOpenMenuRefCb = useRef(onOpenMenu);
  // keep the function in a ref, so we don't need to worry about it in the dependency array
  onOpenMenuRefCb.current = onOpenMenu;
  const menuActiveStateRef = useRef<string>('');

  // run the function when the menu was previously closed but now opened
  useEffect(() => {
    if (isMenuActive && menuActiveStateRef.current !== 'active') {
      onOpenMenuRefCb.current();
      menuActiveStateRef.current = 'active';
    }

    if (!isMenuActive) {
      menuActiveStateRef.current = 'inactive';
    }
  }, [isMenuActive]);
};
